import {mxStylesheet} from "mxgraph-js";

abstract class HCLTreeMxStylesheet extends mxStylesheet {

}

export default HCLTreeMxStylesheet;
